export default "__VITE_ASSET__d44a5dd5__"